<template>
	<div>
		<el-row class="content">
			<el-table v-loading="loading" :data="list" tooltip-effect="light" :cell-style="cellStyle" :header-cell-style="headCellStyle">
				<el-table-column label="序号" prop="recid" width="50" />
				<!--newView:实体类中放一个表中不存在的字段,在查询数据的时候,推送时间小于一天则为true,否则为false-->
				<el-table-column label="消息内容" align="left" prop="xxContent" :show-overflow-tooltip="true" width="600"/>
				<el-table-column label="推送时间" align="center" prop="tsTime" width="200"/>
			</el-table>
			<pagination
					v-show="total>0"
					:total="total"
					:page.sync="queryParams.pageNum"
					:limit.sync="queryParams.pageSize"
					@pagination="getList"
			/>
		</el-row>
	</div>
</template>

<script>

	export default {
		name: 'tsflfgzc',
		data() {
			return {
				// 遮罩层
				loading: false,
				// 总条数
				total: 0,
				list: [],
				queryParams: {
					pageNum: 1,
					pageSize: 10
				},
			}
		},
		created() {
			this.getList();
		},
		methods: {
			//单元格的style的回调方法
			cellStyle({row,column,rowIndex,columnIndex}){
				//columnIndex:是一行一行的从左往右显示
				if(columnIndex === 1){
					return 'padding-left: 10px;';//left是从左往右平移
				}else {
					return ''
				}
			},
			//表头行的style的回调方法    rowIndex:行  columnIndex:列 都是从0开始的
			headCellStyle({row,column,rowIndex,columnIndex}){
				if(columnIndex === 1){
					return 'padding-left: 300px;';
				}else {
					return ''
				}
			},
			toPage(url) {
				this.$router.push({
					path: url,
				});
				this.$store.commit('SET_MAININDEX', url);
			},
			getList() {
				this.loading = true;
				let that = this;
				setTimeout(function() {
					that.loading = false;
					if (that.queryParams.pageNum == 1) {
						that.list = [
							/*{recid: '1',xxContent: '您咨询的问题"转让信息发布如何设置询价"已被处理',tsTime: '2021-10-12 12:12:12'},
							{recid: '2',xxContent: '您申请的"申报小微企业专利权质押贷款利息、专利评估分析费和保证保险费[贷款贴息、评估分析补助]"已办结',tsTime: '2021-10-12 12:12:12'},
							{recid: '3',xxContent: '推送一条新的政策',tsTime: '2021-10-12 12:12:12'},
							{recid: '4',xxContent: '推送一条新的办事指南',tsTime: '2021-10-12 12:12:12'},
							{recid: '5',xxContent: '推送一条新的法律',tsTime: '2021-10-12 12:12:12'},
							{recid: '6',xxContent: '您咨询的问题"转让信息发布如何设置询价"已被处理',tsTime: '2021-10-12 12:12:12'},
							{recid: '7',xxContent: '您申请的"申报小微企业专利权质押贷款利息、专利评估分析费和保证保险费[贷款贴息、评估分析补助]"已办结',tsTime: '2021-10-12 12:12:12'},
							{recid: '8',xxContent: '推送一条新的政策',tsTime: '2021-10-12 12:12:12'},
							{recid: '9',xxContent: '推送一条新的办事指南',tsTime: '2021-10-12 12:12:12'},
							{recid: '10',xxContent: '推送一条新的法律',tsTime: '2021-10-12 12:12:12'},*/
						];
					} else {
						that.list = [
							/*{recid: '11',xxContent: '您咨询的问题"转让信息发布如何设置询价"已被处理',tsTime: '2021-10-12 12:12:12'},
							{recid: '12',xxContent: '您申请的"申报小微企业专利权质押贷款利息、专利评估分析费和保证保险费[贷款贴息、评估分析补助]"已办结',tsTime: '2021-10-12 12:12:12'},
							{recid: '13',xxContent: '推送一条新的政策',tsTime: '2021-10-12 12:12:12'},
							{recid: '14',xxContent: '推送一条新的办事指南',tsTime: '2021-10-12 12:12:12'},
							{recid: '15',xxContent: '推送一条新的法律',tsTime: '2021-10-12 12:12:12'},*/
						];
					}
					that.total = 15;
				}, 500);
			},
		}
	}
</script>

<style scoped="scoped">
	.item {
		margin-top: 10px;
		padding-right: 0.625rem;
	}
</style>
